
export const GRID_SIZE = 12;
export const UNIT_SIZE = 40;
export const COLORS = [
  '#3B82F6', // Blue
  '#EF4444', // Red
  '#10B981', // Green
  '#F59E0B', // Amber
  '#8B5CF6', // Violet
  '#EC4899', // Pink
  '#6B7280', // Gray
  '#000000', // Black
];

export const INITIAL_ROTATION = { x: 30, y: 45 };
